import AdminSlideDrawer from './AdminSlideDrawer';

export default AdminSlideDrawer;
